import styled from "styled-components";

import { theme } from "theme/theme";
import { Table, Button, Modal, Select } from "components";
import { Checkbox } from "antd";

export const PaginationWrapper = styled.div`
  text-align: center;
  ${theme.media.tablet} {
    display: flex;
    justify-content: end;
    text-align: unset;
  }
`;

export const ContentWrapper = styled.div`
  /* margin-bottom: 32px; */
`;

export const SearchWrapper = styled.div`
  ${theme.media.tablet} {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
`;

export const SearchWrapperLeft = styled.div`
  margin-bottom: 24px;
  input {
    width: 100%;
    margin-bottom: 16px;
  }
  div.ant-select-selector {
    height: 30px !important;
  }
  .divider-span {
    font-size: 20px;
    margin-left: 12px;
  }
  ${theme.media.mobileL} {
    .divider-span {
      font-size: 14px;
      margin-left: 0px;
    }
  }
  ${theme.media.tablet} {
    display: flex;
    flex-wrap: wrap;
    /* gap: 24px; */
    input {
      margin-bottom: 0px;
      width: 412px;
      margin-right: 24px;
    }
  }
  ${theme.media.desktop} {
    flex-wrap: nowrap;
    gap: 0px;
  }
`;

export const WrapperSelectAndBtn = styled.div`
  display: flex;
  gap: 8px;
  width: 100%;
  align-items: center;
  button {
    height: 30px;
    width: calc(50% - 4px);
    min-width: max-content;
  }
  .clear-button {
    :focus {
      border: 1px solid #cccccc;
    }
  }
  ${theme.media.mobileM} {
    justify-content: space-between;
    .ant-select {
      width: 231px;
    }
    .ant-select-selector {
      width: 231px;
    }
  }
  ${theme.media.mobileL} {
    justify-content: initial;
    .ant-select {
      margin-right: 16px;
    }
  }
  ${theme.media.tablet} {
    width: max-content;
    .ant-select {
      width: 170px;
    }
    .ant-select-selector {
      width: 170px;
    }
  }
  ${theme.media.laptop} {
    .ant-select {
      width: 175px;
      margin-right: 16px;
    }
    .ant-select-selector {
      width: 175px;
    }
  }
`;

export const RowCellWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 17px;
  svg {
    cursor: pointer;
  }
`;

export const SelectWrapper = styled.div`
  display: flex;
  align-items: center;
  .ant-select-selector {
    background-color: #ffffff !important;
  }
`;

export const ModalStyled = styled(Modal)`
  width: 367px !important;
  max-width: calc(100vw - 8px);
  top: calc(50% - 150px);
  height: 208px !important;
  .ant-modal-body {
    padding: 32px 0px 24px;
    text-align: center;
    font-size: 21px;
    line-height: 40px;
  }
  .ant-modal-footer {
    padding-top: 0;
    padding-bottom: 32px;
    border: unset;
  }
  ${theme.media.tablet} {
    width: 532px !important;
  }
`;

export const WrapperBtnFooter = styled.div`
  display: flex;
  justify-content: center;
  button {
    width: 128px;
    line-height: 16px;
    padding: 12px 0px 12px;
  }
  button:first-child {
    margin-right: 16px;
  }
  ${theme.media.tablet} {
    justify-content: center;
    button:first-child {
      margin-right: 40px;
    }
  }
`;

export const TableStyled = styled(Table)`
  .ant-table-thead tr th {
    padding: 27px 12px 26px 12px;
  }
  .ant-table-tbody tr td {
    padding: 9px 12px 12px 12px;
  }
  .ant-table-thead tr th:last-child {
    text-align: right;
  }
  .ant-table-tbody tr td:last-child {
    text-align: right;
  }
  .ant-checkbox-indeterminate .ant-checkbox-inner::after {
    background-color: ${theme.colors.button};
  }
`;

export const TextModal = styled.div`
  font-size: 22px;
  font-weight: ${theme.fontWeight.bold};
  line-height: 40px;
`;

export const TaskWrapper = styled.div`
  display: flex;
  width: 100%;
  padding: 8px;
  justify-content: flex-end;
  background: #f2f2f2;
  border-radius: 8px 8px 0px 0px;
`;

export const TextLink = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: ${theme.colors.textLink};
  text-decoration: underline;
  cursor: pointer;
`;

export const ActionWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 24px;
  flex-wrap: wrap;
  .left {
    display: flex;
    align-items: center;
    gap: 24px;
  }
  ${theme.media.tablet} {
    flex-wrap: nowrap;
  }
`;

export const WrapperMessage = styled.div`
  padding: 8px 16px 12px;
  background: ${theme.colors.background};
  /* height: 46px; */
  ${theme.media.tablet} {
    height: 46px;
    padding: 8px 16px;
  }
`;

export const Message = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  a {
    color: ${theme.colors.textLink};
    text-decoration: underline;
  }
  button {
    max-width: 248px;
  }

  ${theme.media.mobileXL} {
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
  }

  ${theme.media.tablet} {
    gap: 0px;

    p {
      margin-left: 16px;
    }

    button {
      margin-left: 32px;
      padding: 2.5px 12px;
    }
  }
`;

const Badge = styled.div`
  color: #ffffff;
  padding: 4px 3px 4px;
  border-radius: 2px;
  line-height: 13px;
  font-size: 14px;
`;

export const OtherBadge = styled(Badge)`
  background: #bdbdbd;
  margin-right: 4px;
`;

export const BirthdayBadge = styled(Badge)`
  background: #54a1c5;
  margin-right: 4px;
`;

export const IdentityBadge = styled(Badge)`
  background: #e89806;
  margin-right: 4px;
`;

export const JoinBadge = styled(Badge)`
  background: #4f4f4f;
  margin-right: 4px;
`;

export const RegistrationBadge = styled(Badge)`
  background: #1ab759;
  margin-right: 4px;
`;

export const Item = styled.div`
  display: flex;
  align-items: flex-start;
  margin-top: 2.5px;
  position: relative;
  font-size: 16px;
  line-height: 21px;
  min-height: 32px;

  .special-character {
    border-left: 1px solid #bdbdbd;
    border-bottom: 1px solid #bdbdbd;
    width: 12px;
    height: 18px;
    position: absolute;
    left: 15px; //47px
    top: 0px;
  }

  .age,
  .gender {
    margin-right: 8px;
  }
  .gender {
    width: 64px;
  }
  .age {
    width: 43px;
  }
  .identity-code {
    max-width: 100px;
    word-wrap: break-word;
  }

  @media screen and (min-width: 1360px) {
    .identity-code {
      max-width: unset;
    }
  }
`;

export const WrapperCheckboxAll = styled.div<{ loadingPatient?: boolean }>`
  padding: 12px 12px 12px 14px;
  margin-bottom: 16px;
  box-shadow: 0px 2px 4px 0px #0000001f;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  flex-direction: column;
  opacity: ${(props) => (props.loadingPatient ? 0.5 : 1)};
  pointer-events: ${(props) => (props.loadingPatient ? "none" : "auto")};
  > .ant-checkbox-wrapper:first-child {
    height: 24px;
    align-items: center;
  }
  > .ant-checkbox-wrapper:last-child {
    margin-left: 0px;
  }
  ${theme.media.tablet} {
    flex-direction: row;
    gap: 12px;
    align-items: center;
    justify-content: flex-start;
  }
`;

export const CheckboxStyled = styled(Checkbox)`
  align-items: unset;
  outline: none;

  &:hover {
    .ant-checkbox-inner {
      border-color: #cccccc;
    }
  }

  .ant-checkbox {
    top: unset;
  }

  .ant-checkbox-inner {
    width: 20px;
    height: 21px;
    border: 2px solid #cccccc;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #2ac769;
    border-color: #2ac769 !important;
  }

  .ant-checkbox-checked::after {
    border: none;
  }

  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: #cccccc;
  }

  .ant-checkbox + span {
    padding-right: 0;
    font-size: 16px;
    line-height: 21px;
  }

  .ant-checkbox-indeterminate .ant-checkbox-inner::after {
    background-color: #2ac769;
  }
`;

export const CheckboxTopWrapper = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const CheckboxStyled2 = styled(Checkbox)<{ display?: boolean }>`
  align-items: unset;
  outline: none;

  &:hover {
    .ant-checkbox-inner {
      border-color: #cccccc;
    }
  }

  .ant-checkbox {
    top: unset;
    opacity: ${(props) => (props.display ? 1 : 0)};
    display: ${(props) => (props.display ? "block" : "none")};
  }

  .ant-checkbox-inner {
    width: 20px;
    height: 21px;
    border: 2px solid #cccccc;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #2ac769;
    border-color: #2ac769 !important;
  }

  .ant-checkbox-checked::after {
    border: none;
  }

  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: #cccccc;
  }

  .ant-checkbox + span {
    padding-right: 0;
    font-size: 16px;
    line-height: 21px;
  }
  .ant-checkbox-disabled + span {
    cursor: default;
  }

  .ant-checkbox-indeterminate .ant-checkbox-inner::after {
    background-color: #2ac769;
  }
`;

export const DotLine = styled.div`
  margin: 16px 0;
  border: 1px dashed #e0e0e0;
`;

export const WrapperBadge = styled.div`
  display: flex;
  gap: 4px;
  font-size: 16px;
  line-height: 21px;
`;

export const WrapperCommonInfor = styled.div`
  display: flex;
  align-items: flex-start;
  background: #f9f9fa;
  padding: 3px 6px;
  border-radius: 4px;
  min-height: 27px;
`;

export const UserInputButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;
  margin-top: 0px;
  > div:first-child {
    width: 100%;
  }
  ${theme.media.tablet} {
    width: max-content;
    flex-wrap: nowrap;
    > div:first-child {
      width: max-content;
    }
  }
`;

export const FilterWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  font-weight: 500;
  margin-right: 0px;
  margin-bottom: 16px;
  ${theme.media.tablet} {
    margin-right: 24px;
    margin-bottom: 0px;
  }
`;

export const ListUserWrapper = styled.div<{ loadingPatient?: boolean }>`
  width: max-content;
  min-width: 100%;
  opacity: ${(props) => (props.loadingPatient ? 0.5 : 1)};
  pointer-events: ${(props) => (props.loadingPatient ? "none" : "auto")};
  ${theme.media.laptop} {
    width: 100%;
  }
`;

export const ListUserWrapper2 = styled.div`
  width: 100%;
  overflow-x: scroll;
  ${theme.media.laptop} {
    width: 100%;
    overflow-x: unset;
  }
`;

export const LoadingWrapper = styled.div`
  position: absolute;
  top: 25px;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  svg {
    cursor: default;
  }
`;

export const WrapperExtra = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  ${theme.media.tablet} {
    gap: 12px;
  }
`;

export const AudioWrapper = styled.div`
  flex: 1;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  .ant-radio-wrapper {
    height: max-content;
    align-items: center;
    display: flex;
    margin-right: 0px;
  }
  .ant-radio-wrapper::after {
    display: none;
  }
  .ant-radio-wrapper > span:not(.ant-radio) {
    font-size: 14px;
    line-height: 14px;
    font-weight: 500;
    padding-left: 6px;
    padding-right: 0;
  }
  .ant-radio {
    top: 0;
  }
  .ant-radio-inner {
    border: 2px solid #cccccc;
    width: 20px;
    height: 20px;
  }
  .ant-radio-checked .ant-radio-inner {
    border: 2px solid #cccccc;
    width: 20px;
    height: 20px;
  }
  .ant-radio-inner::after {
    background-color: #2ac769;
    top: calc(50% - 6px);
    left: calc(50% - 6px);
    width: 12px;
    height: 12px;
  }
  .ant-radio:hover .ant-radio-inner,
  .ant-radio:hover .ant-radio-checked .ant-radio-inner {
    border-color: #cccccc;
  }

  ${theme.media.tablet} {
    gap: 24px;
  }
`;

export const FixedWidthName = styled.div<{ width: number }>`
  width: ${(props) => props.width - 32}px;
  ${theme.media.laptop} {
    width: ${(props) => props.width - 24}px;
  }
  ${theme.media.laptopL} {
    width: ${(props) => props.width}px;
  }
`;
